import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGamepad = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0008 3.33301C5.00118 3.33301 1.66699 4.20422 1.66699 9.99967C1.66699 13.333 2.50033 16.6663 5.00033 16.6663C7.50033 16.6663 6.98721 14.1663 10.0003 14.1663C13.0134 14.1663 12.5003 16.6663 15.0003 16.6663C17.5003 16.6663 18.3337 13.333 18.3337 9.99967C18.3337 4.0969 15.0003 3.33301 10.0008 3.33301Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66667 7.5V9.16667M6.66667 10.8333V9.16667M6.66667 9.16667H8.33333M6.66667 9.16667H5",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.4993,
			cy: 8.33333,
			r: .833333,
			fill: "#8A94A6"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.1663,
			cy: 10.0003,
			r: .833333,
			fill: "#8A94A6"
		})
	]
});
const ForwardRef = forwardRef(SvgGamepad);
export { ForwardRef as ReactComponent };
